import { InjectionToken } from '@angular/core';
import { SignageHostConfigurationModel } from '../models';

export const APP_CONFIG = new InjectionToken<SignageHostConfigurationModel>('Signage host configuration');
